export interface ParsedMcpTool {
  readonly isMcp: true
  readonly serverName: string
  readonly actionName: string
}

export interface NonMcpTool {
  readonly isMcp: false
}

export type McpToolParseResult = ParsedMcpTool | NonMcpTool

export interface FormattedMcpTool {
  readonly toolDisplayName: string
  readonly actionDisplayName: string
}

export function formatMcpToolForDisplay(rawToolName: string): FormattedMcpTool | null {
  const result = parseMcpToolName(rawToolName)
  if (!result.isMcp) return null

  return {
    toolDisplayName: `MCP Server ${result.serverName}`,
    actionDisplayName: result.actionName,
  }
}

export function parseMcpToolName(toolName: string): McpToolParseResult {
  if (!toolName.startsWith('mcp__')) {
    return { isMcp: false }
  }

  const parts = toolName.split('__')
  if (parts.length !== 3) {
    return { isMcp: false }
  }

  const serverName = parts[1]
  const action = parts[2]

  if (!serverName || !action) {
    return { isMcp: false }
  }

  return {
    isMcp: true,
    serverName: formatName(serverName),
    actionName: formatName(action),
  }
}

function capitalizeFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

function formatName(name: string): string {
  return name
    .split(/[-_]/)
    .map((word) => capitalizeFirst(word))
    .join(' ')
}

export function formatToolNameForDisplay(toolName: string): string {
  const mcpFormatted = formatMcpToolForDisplay(toolName)
  if (mcpFormatted) {
    return mcpFormatted.toolDisplayName
  }

  return toolName
    .replaceAll(/([a-z])([A-Z])/g, '$1 $2')
    .replaceAll(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
}
